/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Parsing_DescriptionInputs */



/**
* | output |
* | --- |
* | "Parsing work order description" |
*
* @param {Work_Order_Import_Status_Parsing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_parsing_description = /** @type {((inputs?: Work_Order_Import_Status_Parsing_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Parsing_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Analyse de la description de l’ordre de travail")
	if (locale === "de") return /** @type {LocalizedString} */ ("Analyse der Arbeitsauftragsbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Analisi della descrizione dell'ordine di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Анализ описания заказа на выполнение работ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Análisis de la descripción de la orden de trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("解析工单描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作業指示書の説明を解析する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य आदेश विवरण का विश्लेषण करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Analisando a descrição da ordem de serviço")
	return /** @type {LocalizedString} */ ("Parsing work order description")
});